import axios from 'axios';

export default {
  template: "#vue-cancellation-portal",
  delimiters: ['${', '}'],
  props: [
    "customer_id",
    "customer_email"
  ],
  data() {
    const urlParams = new URLSearchParams(window.location.search);
    return {
      customer: {
        id: this.customer_id || null,
        email: urlParams.get('email') || this.customer_email || '',
      },
      order_number: urlParams.get('order') || '',
      postal_code: urlParams.get('postal_code') || '',
      submitting: false,

      submission_error: null,
      submission_response: null,
    }
  },
  computed: {},
  methods: {
    submit_cancellation(evt) {
      evt.preventDefault()
      if (this.submitting) {
        return
      }
      if (this.$refs['initiation_form'].reportValidity()) {
        this.submitting = true
        this.submission_error = null
        this.submission_response = null
        axios.post('/apps/api/cancellations/request',
            {
              order_number: this.order_number,
              email: this.customer.email,
              postal_code: this.postal_code,
              locale: this.$store.state.lang
            })
        .then(
            resp => {
              this.submission_response = resp.data
              this.submitting = false
            }, err => {
              this.submission_error = (err.response && err.response.data ? err.response.data.error : null) || 'unspecified error'
              this.submitting = false
            }
        )
      }
    }
  },
  mounted() {

  }
}